export default "__VITE_ASSET__10be732c__"